import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WatabiUrlService } from './watabi-url.service';
import { InstanceModule } from 'libraries/service/instance/instance.module';

@NgModule({
    imports: [
        CommonModule,
        InstanceModule,
    ],
    declarations: [],
    exports: [],
    providers: [WatabiUrlService],
})
export class WatabiUrlModule { }